var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayOutline = function SvgPlayOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.197 11.02-.248.434L6.815 5.1a.777.777 0 0 0-.761-.001.733.733 0 0 0-.375.634v12.534c0 .257.142.5.37.631a.774.774 0 0 0 .758.006l11.134-6.18a.734.734 0 0 0 .38-.634.732.732 0 0 0-.372-.636l.248-.435Zm1.124 1.076a1.733 1.733 0 0 1-.895 1.502l-11.134 6.18a1.773 1.773 0 0 1-1.74-.012 1.733 1.733 0 0 1-.873-1.499V5.733c0-.62.338-1.197.882-1.504a1.777 1.777 0 0 1 1.75.003l11.133 6.353c.544.31.88.888.877 1.51Z",
    fill: "currentColor"
  })));
};
export default SvgPlayOutline;